import { getThemeAsset } from "@utils/theme";
import { motion } from "framer-motion";
import { ANIMATION_STATE, SKINNER_BOX_STATE, INTERACTION_STATE, circleVariants, shineImageVariants } from "../utils";
import { cn } from "kz-ui-sdk";

interface SkinnerBoxBackgroundProps {
  animationState: ANIMATION_STATE;
  zIndex: number;
  state?: SKINNER_BOX_STATE;
  isClicked: boolean;
}

const SkinnerBoxBackground = ({ animationState, zIndex, state, isClicked }: SkinnerBoxBackgroundProps) => {
  const imgShine = getThemeAsset("/skinner-box/shine.png");
  const shineImageState = isClicked ? INTERACTION_STATE.CLICKED : INTERACTION_STATE.IDLE;

  return (
    <>
      <div
        className={cn(
          "absolute inset-0 m-auto h-[83px] w-[83px] shrink-0 rounded-full border-2",
          isClicked ? "border-stroke-highlight" : "border-darkBrand-400",
        )}
      />

      <motion.div
        className={cn(
          "absolute inset-0 m-auto h-[80px] w-[80px] shrink-0 rounded-full border-[3px] overflow-hidden transition-all duration-300 ease-in-out",
          isClicked ? "border-stroke-highlight" : "border-brand-400",
        )}
        variants={shineImageVariants}
        animate={shineImageState}
        initial={INTERACTION_STATE.IDLE}
      >
        <img
          src={imgShine}
          alt="Shine background"
          className="h-full w-full object-contain"
        />
      </motion.div>

      <motion.div
        className="absolute inset-0 m-auto flex h-[75px] w-[75px] shrink-0 items-center justify-center rounded-full opacity-60"
        style={{ zIndex }}
        variants={circleVariants}
        initial={ANIMATION_STATE.IDLE}
        animate={animationState}
      >
        <div className="absolute inset-0 rounded-full border-2 border-stroke-base" />
        <img
          src={imgShine}
          alt="Circle BG"
          className="h-full w-full rounded-full object-contain"
        />
      </motion.div>
    </>
  );
};

export default SkinnerBoxBackground;
